import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { SpinnerDialogComponent } from '../../dialogs/spinner-dialog/spinner-dialog.component'
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component'
import { SharedService } from '../../services/shared.service'
import { Product } from '../../models/product'
import { HttpService } from '../../services/http.service'

@Component({
	selector: 'app-personal-info',
	templateUrl: './personal-info.component.html',
	styleUrls: ['./personal-info.component.css']
})
export class PersonalInfoComponent {
	serialNumber: string
	product: Product
	form: FormGroup
	states = [
		{ title: 'Alabama', value: 'AL' },
		{ title: 'Alaska', value: 'AK' },
		{ title: 'Arizona', value: 'AZ' },
		{ title: 'Arkansas', value: 'AR' },
		{ title: 'California', value: 'CA' },
		{ title: 'Colorado', value: 'CO' },
		{ title: 'Connecticut', value: 'CT' },
		{ title: 'Delaware', value: 'DE' },
		{ title: 'District Of Columbia', value: 'DC' },
		{ title: 'Florida', value: 'FL' },
		{ title: 'Georgia', value: 'GA' },
		{ title: 'Hawaii', value: 'HI' },
		{ title: 'Idaho', value: 'ID' },
		{ title: 'Illinois', value: 'IL' },
		{ title: 'Indiana', value: 'IN' },
		{ title: 'Iowa', value: 'IA' },
		{ title: 'Kansas', value: 'KS' },
		{ title: 'Kentucky', value: 'KY' },
		{ title: 'Louisiana', value: 'LA' },
		{ title: 'Maine', value: 'ME' },
		{ title: 'Maryland', value: 'MD' },
		{ title: 'Massachusetts', value: 'MA' },
		{ title: 'Michigan', value: 'MI' },
		{ title: 'Minnesota', value: 'MN' },
		{ title: 'Mississippi', value: 'MS' },
		{ title: 'Missouri', value: 'MO' },
		{ title: 'Montana', value: 'MT' },
		{ title: 'Nebraska', value: 'NE' },
		{ title: 'Nevada', value: 'NV' },
		{ title: 'New Hampshire', value: 'NH' },
		{ title: 'New Jersey', value: 'NJ' },
		{ title: 'New Mexico', value: 'NM' },
		{ title: 'New York', value: 'NY' },
		{ title: 'North Carolina', value: 'NC' },
		{ title: 'North Dakota', value: 'ND' },
		{ title: 'Ohio', value: 'OH' },
		{ title: 'Oklahoma', value: 'OK' },
		{ title: 'Oregon', value: 'OR' },
		{ title: 'Pennsylvania', value: 'PA' },
		{ title: 'Rhode Island', value: 'RI' },
		{ title: 'South Carolina', value: 'SC' },
		{ title: 'South Dakota', value: 'SD' },
		{ title: 'Tennessee', value: 'TN' },
		{ title: 'Texas', value: 'TX' },
		{ title: 'Utah', value: 'UT' },
		{ title: 'Vermont', value: 'VT' },
		{ title: 'Virginia', value: 'VA' },
		{ title: 'Washington', value: 'WA' },
		{ title: 'West Virginia', value: 'WV' },
		{ title: 'Wisconsin', value: 'WI' },
		{ title: 'Wyoming', value: 'WY' }
	]
	spinner: MatDialogRef<SpinnerDialogComponent>

	getTitle(value: string): string {
		for (const state of this.states) {
			if (state.value == value) return state.title
		}
		return ''
	}

	constructor(
		private router: Router,
		private shared: SharedService,
		public dialog: MatDialog,
		private formBuilder: FormBuilder,
		private http: HttpService,
	) {
		this.shared.blockRefresh()
		let user = this.shared.user
		this.product = this.shared.product
		this.serialNumber = this.shared.serialNumber
		this.form = this.formBuilder.group({
			firstName: [
				user.firstName,
				Validators.required
			],
			lastName: [
				user.lastName,
				Validators.required
			],
			address1: [
				user.address1,
				Validators.required
			],
			address2: [
				user.address2,
				Validators.maxLength(50)
			],
			locality: [
				user.locality, [
					Validators.required,
					Validators.maxLength(50)
				]
			],
			administrativeArea: [
				user.administrativeArea,
				Validators.required
			],
			postalCode: [
				user.postalCode, [
					Validators.required,
					Validators.pattern('^[0-9]*$'),
					Validators.minLength(5),
					Validators.maxLength(5)
				]
			],
			email: [
				user.email, [
					Validators.required,
					Validators.email,
					Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
					Validators.maxLength(100)
				]
			],
			phoneNumber: [
				this.maskPhoneNumber(user.phoneNumber), [
					Validators.required,
					Validators.pattern('^[0-9\-]*$'),
					// Validators.minLength(10),
					// Validators.maxLength(12)
				]
			],
			phoneNumber2: [
				user.phoneNumber2,
			]
		})
	}

	keyPressNumbersOnly(event: any) {
		this.shared.keyPressNumbersOnly(event)
	}

	keyPressAlphabetsOnly(event: any) {
		this.shared.keyPressAlphabetsOnly(event)
	}

	keyPressAlphaNumericOnly(event: any) {
		this.shared.keyPressAlphaNumericOnly(event)
	}

	keyPressAlphaNumericSpaceOnly(event: any) {
		this.shared.keyPressAlphaNumericSpaceOnly(event)
	}
	
	formatPhoneNumber(s: String): void {
		this.form.value.phoneNumber = this.maskPhoneNumber(s)
	}

	maskPhoneNumber(s: String): String {
		const value = s.replace(/[^0-9]/g, '')
		let format = '***-***-****'
		for (let i = 0; i < value.length; i++) format = format.replace('*', value.charAt(i));
		if (format.indexOf('*') >= 0) format = format.substring(0, format.indexOf('*'));
		return format.trim()
	}

	onPrevious(): void {
		this.router.navigateByUrl('/terms-and-conditions')
	}

	onNext(): void {
		this.shared.user = this.shared.empty_user
		this.shared.user = JSON.parse(JSON.stringify(this.form.value))
		this.shared.user.country = 'US'
		this.shared.user.phoneNumber = this.shared.user.phoneNumber.replace(/-/g, '')
		this.spinner = this.dialog.open(SpinnerDialogComponent, {
			panelClass: 'transparent',
			disableClose: true
		})
		
		this.http.getTax(this.shared.serialNumber, this.shared.user.postalCode, this.shared.user.country, this.shared.product)
			.subscribe((response) => {
				console.log(response)
				this.spinner.close()
				if (response.success == false) {
					this.dialog.open(
						MessageDialogComponent, {
						data: {
							title: '',
							description: response.message,
							button: 'Close'
						}
					})
				} else {
					this.shared.price = response.data.subtotal.toFixed(2)
					this.shared.tax = response.data.totalTax.toFixed(2)
					this.shared.taxrate = response.data.taxRate.toFixed(2)
					this.shared.total = response.data.total.toFixed(2)
					this.router.navigateByUrl('/payment')
				}
			}, (error) => {
				this.spinner.close()
				this.dialog.open(
					MessageDialogComponent, {
					data: {
						title: '',
						description: error.message,
						button: 'Close'
					}
				})
			})		
	}
}